import { Guardian } from '@xaamin/guardian';

Guardian.define('pac.crear', (user) => {
  return user.can('pac.crear');
});

Guardian.define('pac.listar', (user) => {
  return user.can('pac.listar');
});

Guardian.define('pac.info', (user) => {
  return user.can('pac.info');
});

Guardian.define('pac.asignar.hits', (user) => {
  return user.can('pac.asignar.hits');
});

Guardian.define('pac.editar', (user) => {
  return user.can('pac.editar');
});

Guardian.define('pac.priorizar', (user) => {
  return user.can('pac.priorizar');
});

Guardian.define('pac.principal', (user) => {
  return user.can('pac.principal');
});

Guardian.define('pac.penalizar', (user) => {
  return user.can('pac.penalizar');
});

Guardian.define('pac.suspender', (user) => {
  return user.can('pac.suspender');
});

Guardian.define('pac.activar', (user) => {
  return user.can('pac.activar');
});

Guardian.define('pac.estrategias', (user) => {
  return user.can('pac.estrategias');
});